"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismicCollectionInfo", {
  enumerable: true,
  get: function get() {
    return _usePrismicCollectionInfo["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismicCollectionInfo = _interopRequireDefault(require("./usePrismicCollectionInfo"));
var _fetcher = _interopRequireDefault(require("./fetcher"));